import React, { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { Product, Partner, Sale, Customer } from 'models';
import { CustomerService, ProductService, PartnerService, SalesService } from 'services';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { RecordLateSaleDialogProps } from './RecordLateSaleDialogProps';

export const RecordLateSaleDialog = ({ open, closeDialog }: RecordLateSaleDialogProps) => {
	const [users, setUsers] = useState([] as Customer[]);
	const [products, setProducts] = useState([] as Product[]);
	const [partners, setPartners] = useState([] as Partner[]);
	const [recordLateSaleData, setRecorLateSaleData] = useState({
		user: 0,
		partner: 0,
		product: 0,
		timeStamp: new Date(),
	});
	const handleInputChange = (event: any) => {
		const { name, value } = event.target;
		setRecorLateSaleData({ ...recordLateSaleData, [name]: value });
	};
	const handleRecordLateSale = async () => {
		await SalesService.create({
			userId: recordLateSaleData.user,
			partnerId: recordLateSaleData.partner,
			productId: recordLateSaleData.product,
			timeStamp: recordLateSaleData.timeStamp,
		} as Sale);
		closeDialog();
	};
	const initComponent = async () => {
		setUsers(await CustomerService.getAll());
		setProducts(await ProductService.getAll());
		setPartners(await PartnerService.getAll());
	};
	const processMinDate = () => {
		if (new Date().getDate() <= 2) return dayjs(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1));
		else return dayjs(new Date(new Date().getFullYear(), new Date().getMonth(), 1));
	};
	useEffect(() => {
		initComponent();
	}, [open]);
	return (
		<Dialog open={open} onClose={() => closeDialog()} fullWidth>
			<DialogTitle variant='h5'>Record late sale</DialogTitle>
			<DialogContent>
				<Grid container p={2}>
					<Grid item xs={12}>
						{partners && partners.length > 0 && (
							<>
								<Autocomplete
									options={users}
									getOptionLabel={option => `${option.firstName} ${option.lastName}`}
									value={users.find(user => user.id === recordLateSaleData.user) ?? null}
									onChange={event => handleInputChange(event)}
									renderInput={params => <TextField {...params} label='Customer' size='small' />}
								/>
							</>
						)}
					</Grid>
				</Grid>
				<Grid container p={2}>
					<Grid item xs={12}>
						{partners && partners.length > 0 && (
							<>
								<Autocomplete
									options={partners}
									getOptionLabel={option => `${option.firstName} ${option.lastName}`}
									value={partners.find(partner => partner.id === recordLateSaleData.partner) ?? null}
									onChange={event => handleInputChange(event)}
									renderInput={params => <TextField {...params} label='Partner' size='small' />}
								/>
							</>
						)}
					</Grid>
				</Grid>
				<Grid container p={2}>
					<Grid item xs={12}>
						{products && products.length > 0 && (
							<>
								<Autocomplete
									options={products}
									getOptionLabel={option => `${option.name}`}
									value={products.find(product => product.id === recordLateSaleData.product) ?? null}
									onChange={event => handleInputChange(event)}
									renderInput={params => <TextField {...params} label='Product' size='small' />}
								/>
							</>
						)}
					</Grid>
				</Grid>
				<Grid container p={2}>
					<Grid item xs={12}>
						<DatePicker
							name='timeStamp'
							sx={{ width: '100%' }}
							slotProps={{
								textField: {
									size: 'small',
									required: true,
									fullWidth: true,
								},
							}}
							minDate={processMinDate()}
							value={dayjs(recordLateSaleData.timeStamp)}
							label='Sale date'
							onChange={value => setRecorLateSaleData({ ...recordLateSaleData, timeStamp: value?.toDate() ?? new Date() })}
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button variant='contained' color='error' onClick={() => closeDialog()}>
					Cancel
				</Button>
				<Button variant='contained' color='primary' onClick={handleRecordLateSale}>
					Record
				</Button>
			</DialogActions>
		</Dialog>
	);
};